import script from "./KycReviewViewChange.vue?vue&type=script&setup=true&lang=js"
export * from "./KycReviewViewChange.vue?vue&type=script&setup=true&lang=js"

import "./KycReviewViewChange.vue?vue&type=style&index=0&id=c1c982e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1c982e2"]])

export default __exports__